import { render, staticRenderFns } from "./Circle.vue?vue&type=template&id=138f320a&scoped=true&"
import script from "./Circle.vue?vue&type=script&lang=js&"
export * from "./Circle.vue?vue&type=script&lang=js&"
import style0 from "./Circle.vue?vue&type=style&index=0&id=138f320a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f320a",
  null
  
)

export default component.exports